/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {AuthProvider} from 'react-auth-kit'
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom'
import {App} from '../App'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {PrivateRoutes} from './PrivateRoutes'
// import refreshApi from "./refreshApi"

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  return (
    <AuthProvider authName={'_auth'} authType={'cookie'}>
      <BrowserRouter basename={PUBLIC_URL}>
        <Routes>
          <Route element={<App />}>
            <Route path='error/*' element={<ErrorsPage />} />
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}

export {AppRoutes}
